/*
 * 埋点上报功能
 *
 * 使用方法：
 * import uploadEt from '@/utils/et'
 * uploadEt({"event_type":1,//参考下面 event_type 表格传参
            "product_id":1,//需要货品 id 的事件需要传
            "sku_id":1//需要 skuid 的事件需要传})
 *
 * https://docs.kuaipidev.com/pages/viewpage.action?pageId=60133149
 */

import apis from '@/apis'
import { storageUtil } from '@/utils'

const { etApi } = apis
const { getLocalStorage } = storageUtil

interface Product {
  product_id: string | undefined
  sku_id?: Array<string>
}

interface Properties {
  event_type: number
  products?: Array<Product>
  sku_id?: string
}

const uploadEt = async (params: Properties) => {
  try {
    const corpInfo = getLocalStorage('corpInfo', true) || {}
    const { corpId } = corpInfo

    const data = JSON.stringify({
      event: 'paifa.statis',
      distinct_id: localStorage.getItem('uuid') || '',
      properties: params,
      ...(corpId && { corpId }),
    })

    etApi.uploadEt({ data: window.btoa(data) })
  } catch (e) {
    console.log(e)
  }
}

/**
 * 7.8.3 需求埋点（https://www.tapd.cn/57403764/prong/stories/view/1157403764001019483）
 * @param eventType 事件类型
 */
export async function uploadCommonEt(eventType: number) {
  try {
    const corpInfo = getLocalStorage('corpInfo', true) || {}
    const staffId = getLocalStorage('staffId')
    const { corpId } = corpInfo

    const data = {
      ...(corpId && { corpId }),
      time: Date.now(),
      event: 'common.event',
      properties: {
        ...(staffId && { staffId }),
        eventType,
      },
    }

    console.log('7.8.3 需求埋点', data)
    etApi.uploadEt({ data: window.btoa(JSON.stringify(data)) })
  } catch (e) {
    console.log(e)
  }
}

export default uploadEt
